import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { fmtErr } from "@/lib/api";
import PasswordInput from "@/components/PasswordInput";
import { usePageMeta } from "@/lib/seo";

export default function ResetPassword() {
  usePageMeta({ title: "Reset password | Solis Casting", noindex: true });
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { toast.error("Passwords don't match."); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
    } catch (err) {
      toast.error(fmtErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[85vh] flex items-center px-6 sm:px-10" data-testid="reset-password-page">
      <div className="max-w-md mx-auto w-full">
        {!token ? (
          <>
            <p className="overline-label mb-6">Broken link</p>
            <h1 className="font-display font-light text-4xl tracking-tighter mb-8">This reset link is missing its key.</h1>
            <p className="text-sm text-muted-foreground mb-10">Request a fresh one from the sign-in page.</p>
            <Link to="/auth" data-testid="reset-goto-auth" className="btn-primary inline-block">Back to sign in</Link>
          </>
        ) : done ? (
          <>
            <p className="overline-label mb-6 !text-accent">Done</p>
            <h1 className="font-display font-light text-4xl tracking-tighter mb-8">New key, same door.</h1>
            <p className="text-sm text-muted-foreground mb-10">Your password has been updated. Sign in with it now.</p>
            <Link to="/auth" data-testid="reset-success-signin" className="btn-primary inline-block">Sign in</Link>
          </>
        ) : (
          <form onSubmit={submit}>
            <p className="overline-label mb-6">Reset password</p>
            <h1 className="font-display font-light text-4xl sm:text-5xl tracking-tighter mb-12">
              Choose a new <span className="italic">key.</span>
            </h1>
            <PasswordInput data-testid="reset-password-input" required minLength={8} value={password}
              onChange={(e) => setPassword(e.target.value)} placeholder="New password (8+ characters)" className="field mb-6" autoComplete="new-password" />
            <PasswordInput data-testid="reset-password-confirm" required minLength={8} value={confirm}
              onChange={(e) => setConfirm(e.target.value)} placeholder="Repeat the new password" className="field mb-10" autoComplete="new-password" />
            <button data-testid="reset-password-submit" disabled={busy} className="btn-primary w-full disabled:opacity-40">
              {busy ? "One moment…" : "Update password"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
